import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';
import { consent } from '@axo/shared/data-access/types';
import { MarketCountryCode } from '@axo/shared/types';

export const getConsentConfig =
  (baseURL: string) =>
  async (country: MarketCountryCode): Promise<consent.ConsentConfigSnapshot> =>
    send({
      baseURL,
      path: `/consent/v1/config/snapshot/${country}`,
      method: 'GET',
    });

export const sendMasterConsent =
  ({ url: { service: baseUrl }, token }: IAPI) =>
  async (data: consent.ConsentConfigData) =>
    send({
      baseURL: baseUrl,
      token,
      path: `/consent/v1/consent`,
      method: 'POST',
      body: data,
    });
